import React from 'react';
import { Pressable } from 'react-native';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
export const Block = ({ children, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Pressable, { style: (state) => {
            const extendedState = state;
            return [
                styles.container,
                extendedState.hovered ? styles.container__isHovered : {},
                style
            ];
        } }, (state) => {
        const extendedState = state;
        return typeof children === 'function'
            ? children(extendedState)
            : children;
    }));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        borderRadius: size.E
    },
    container__isHovered: {
        backgroundColor: color.invert2.p4,
        cursor: 'default'
    }
}));
//# sourceMappingURL=Block.js.map